import { PageBanner } from '@components/PageBanner';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import DestinationDiscover from './DestinationPage/DestinationDiscover';
import DestinationMap from './DestinationPage/DestinationMap';
import { selectBannerDestination } from './selectors';

interface HotelProps {
  park: string;
}

const Destination = memo(({ park }: HotelProps) => {
  const banner = useSelector(selectBannerDestination);

  return (
    <main id="destination">
      <PageBanner banner={banner} />
      <DestinationDiscover park={park} />
      <DestinationMap />
    </main>
  );
});

export default Destination;
